import { render, staticRenderFns } from "./ContactTagsModal.vue?vue&type=template&id=57c15c5b&"
import script from "./ContactTagsModal.vue?vue&type=script&lang=ts&"
export * from "./ContactTagsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c15c5b')) {
      api.createRecord('57c15c5b', component.options)
    } else {
      api.reload('57c15c5b', component.options)
    }
    module.hot.accept("./ContactTagsModal.vue?vue&type=template&id=57c15c5b&", function () {
      api.rerender('57c15c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/ContactTagsModal.vue"
export default component.exports